import React, { useEffect, useState } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { Button, message, DatePicker } from 'antd';
import { observer } from 'mobx-react';
import { UserEditDialogState } from '../UserEditDialogState';
import { action } from 'mobx';
import moment from 'moment';
import { UserStatus } from '../../../../models/user';

export interface IUserEditChangeDiscountDialogProps {
  editDialogState: UserEditDialogState;
  isOpen: boolean;
  onClose: () => void;
}

export const UserEditChangeDiscountDialog: React.FC<IUserEditChangeDiscountDialogProps> = observer(
  ({ editDialogState, isOpen, onClose }) => {
    const [dateFrom, setDateFrom] = useState<moment.Moment | null>(moment());

    useEffect(() => {
      let firstChangeDateFrom = moment();
      if (editDialogState.userModel.Status === UserStatus.ClaimVisit) {
        firstChangeDateFrom = moment(editDialogState.userModel.RegisterDate);
      }

      if (isOpen) {
        setDateFrom(
          editDialogState.userModel.newDiscountDateFrom != null
            ? editDialogState.userModel.newDiscountDateFrom
            : firstChangeDateFrom
        );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const handleApply = action(() => {
      if (dateFrom === null) {
        message.warning('Не задана дата начала скидки', 3);
        return;
      }

      editDialogState.userModel.newDiscountDateFrom = dateFrom;

      onClose();
    });

    const handleCancel = () => {
      onClose();
    };

    return (
      <Modal
        className="UserEditDialog-NewDiscountDate"
        visible={isOpen}
        title="Введите дату начала скидки"
        onCancel={handleCancel}
        footer={[
          <Button key="apply" onClick={handleApply}>
            Применить
          </Button>,
          <Button key="back" onClick={handleCancel}>
            Закрыть
          </Button>,
        ]}
      >
        <DatePicker format="DD.MM.YYYY" value={dateFrom} onChange={(value) => setDateFrom(value)} />
      </Modal>
    );
  }
);
